/* eslint-disable no-shadow */
import useSWR from 'swr';

import { fetchRefreshes } from 'src/store/api';

const defaultConfig = {
  shouldFetch: true,
  revalidateIfStale: false,
  revalidateOnMount: false,
  revalidateOnFocus: false,
};

export default function useRefreshes({ query, options = {}, config = {} }) {
  const { shouldFetch, ...swrConfig } = { ...defaultConfig, ...config };

  const url = `/core/v1/refreshes/?query=${JSON.stringify(query)}`;
  const { fields = '*', ...requestQuery } = query;
  const requestOptions = {
    headers: {
      'X-Fields': fields,
    },
    ...options,
  };

  return useSWR(
    shouldFetch ? { key: url, requestQuery, requestOptions } : null,
    ({ requestQuery: q, requestOptions: o }) => fetchRefreshes(q, o),
    swrConfig
  );
}
